import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Review } from '../data/reviews';
interface ReviewCardProps {
  review: Review;
}
export function ReviewCard({
  review
}: ReviewCardProps) {
  return <article className="flex h-full flex-col rounded-2xl border border-line bg-white p-6" data-id="element-93" data-mp="3o8rvffuplubu">
      <div className="flex items-center gap-1" aria-label="Calificación: 5 de 5 estrellas" data-id="element-94" data-mp="3jhji48q9dote">
        {Array.from({
        length: 5
      }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-cobalt text-cobalt" aria-hidden="true" data-id="element-95" data-mp="15wtcmp8r60d" data-mpi={index} />)}
      </div>

      <p className="mt-4 text-sm leading-relaxed text-navy" data-id="element-96" data-mp="b0ye76chhlx5">“{review.comment}”</p>

      <footer className="mt-auto pt-5" data-id="element-97" data-mp="62n6p29nvni3">
        <p className="font-display text-sm font-bold text-navy" data-id="element-98" data-mp="63ohr6qog9zt">{review.author}</p>
        <p className="mt-0.5 text-[11px] font-semibold uppercase tracking-wide text-mute" data-id="element-99" data-mp="2cu5xsrz4qpou">
          Compró {review.product}
        </p>
      </footer>
    </article>;
}